import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';

// Class name used to blur page content
export const classNameBlurred = 'blurred';

export const GlobalStyle = createGlobalStyle`
  ${normalize};

  *, ::after, ::before {
    box-sizing: border-box;
  }

  html, body, #root {
    height: 100%;
    margin: 0;
    overflow: hidden;
    padding: 0;
    width: 100%;
  }
  
  #root {
    display: flex;
    flex-direction: column;
  }

  html {
    font-family: 'Inter', sans-serif;
    font-size: 15px;
    font-weight: 400;
    line-height: 1.4em;
  }

  body {
    background-color: ${({ theme }) => theme.body.background};
    color: ${({ theme }) => theme.body.color};
  }
  
  a {
    color: ${({ theme }) => theme.link.color};
    text-decoration: none;
    transition: color ${({ theme }) => theme.transition.medium} ease-in-out;

    &:hover {
      color: ${({ theme }) => theme.link.hover.color};
    }
  }
  
  abbr[title] {
    border: none;
    text-decoration: none;
  }
  
  code {
    background-color: ${({ theme }) => theme.element.code.background};
    border-radius: ${({ theme }) => theme.radius.small};
    padding: ${({ theme }) => theme.spacing.relative.tiny};
    white-space: nowrap;
  }
  
  kbd {
    align-items: center;
    background-color: ${({ theme }) => theme.element.kbd.background};
    border-radius: ${({ theme }) => theme.radius.small};
    box-shadow: ${({ theme }) => theme.element.kbd.shadow};
    display: inline-flex;
    justify-content: center;
    font-family: inherit;
    font-size: 0.9em;
    line-height: 1em;
    margin: 0 0.1em;
    padding: ${({ theme }) => theme.spacing.relative.tiny} ${({ theme }) =>
  theme.spacing.relative.small};
    user-select: none;
    white-space: nowrap;
    
    svg {
      font-size: inherit;
      line-height: inherit;
    }
  }
  
  ol,
  ul {
    margin: 0;

    li {
      line-height: 1.8em;
    }
  }
  
  p {
    line-height: 1.6em;
    margin: 0;

    & + & {
      margin-top: ${({ theme }) => theme.spacing.relative.smaller};
    }
  }
  
  strong {
    font-weight: 600;
  }

  textarea::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.input.background};
  }

  textarea::-webkit-scrollbar-thumb {
    border: ${({ theme }) => theme.scrollbar.track.spacing}px solid ${({ theme }) =>
  theme.input.background};
  }
  
  .os-theme-adelante {
    .os-scrollbar {
      > .os-scrollbar-track {
        > .os-scrollbar-handle {
          background-color: ${({ theme }) => theme.scrollbar.thumb.background};
        }
      }

      &:hover {
        > .os-scrollbar-track {
          > .os-scrollbar-handle {
            background-color: ${({ theme }) => theme.scrollbar.thumb.hover};
          }
        }
      }
    }
    
    .os-scrollbar-horizontal {
      height: ${({ theme }) => theme.scrollbar.thumb.size}px;
      padding: ${({ theme }) => theme.scrollbar.track.spacing}px;
      right: 0;
    }

    .os-scrollbar-vertical {
      bottom: 0;
      padding: ${({ theme }) => theme.scrollbar.track.spacing}px;
      width: ${({ theme }) => theme.scrollbar.thumb.size}px;
    }
  }

  *::selection {
    background-color: ${({ theme }) => theme.selection.background};
    color: ${({ theme }) => theme.selection.color};
  }

  *::-webkit-scrollbar {
    cursor: default;
    height: ${({ theme }) => theme.scrollbar.thumb.size}px;
    width: ${({ theme }) => theme.scrollbar.thumb.size}px;
  }

  *::-webkit-scrollbar-button {
    display: none;
    height: 0;
    width: 0;
  }

  *::-webkit-scrollbar-corner,
  *::-webkit-scrollbar-track {
    background-color: transparent;
  }

  *::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.scrollbar.thumb.background};
    border: ${({ theme }) => theme.scrollbar.track.spacing}px solid transparent;
    border-radius: ${({ theme }) => theme.scrollbar.thumb.size / 2}px;
    padding: ${({ theme }) => theme.scrollbar.track.spacing}px;

    &:hover {
      background-color: ${({ theme }) => theme.scrollbar.thumb.hover};
    }
  }
`;
